import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../lib/api';
import { AdminPageHeader } from './AdminLayout';
import { FileText, Newspaper, Globe, Map, Users, Inbox, ShieldCheck, ArrowUpRight } from 'lucide-react';

const CARDS = [
  { key: 'pages', Icon: FileText, label: 'Pages', to: '/admin/pages', endpoint: '/admin/pages' },
  { key: 'articles', Icon: Newspaper, label: 'Articles', to: '/admin/articles', endpoint: '/admin/articles' },
  { key: 'languages', Icon: Globe, label: 'Languages', to: '/admin/languages', endpoint: '/admin/languages' },
  { key: 'countries', Icon: Map, label: 'Countries', to: '/admin/countries', endpoint: '/admin/countries' },
  { key: 'contacts', Icon: Inbox, label: 'Contacts', to: '/admin/contacts', endpoint: '/admin/contacts' },
  { key: 'users', Icon: Users, label: 'Users', to: '/admin/users', endpoint: '/admin/users' },
  { key: 'roles', Icon: ShieldCheck, label: 'Roles', to: '/admin/roles', endpoint: '/admin/roles' },
];

export default function AdminDashboard() {
  const [counts, setCounts] = useState({});
  useEffect(() => {
    Promise.all(CARDS.map((c) => api.get(c.endpoint).then((r) => [c.key, r.data?.length || 0]).catch(() => [c.key, 0])))
      .then((entries) => setCounts(Object.fromEntries(entries)));
  }, []);
  return (
    <div>
      <AdminPageHeader title="Welcome back" description="Quick overview of your ClicksyHub workspace." />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {CARDS.map((c) => (
          <Link key={c.key} to={c.to} className="group rounded-3xl bg-white border border-black/10 p-6 lift-card flex items-center gap-4">
            <div className="w-12 h-12 rounded-2xl bg-[#F4E94B] flex items-center justify-center"><c.Icon size={20} /></div>
            <div className="flex-1">
              <p className="text-xs uppercase tracking-widest font-semibold text-stone-500">{c.label}</p>
              <p className="heading-display text-3xl">{counts[c.key] ?? '—'}</p>
            </div>
            <ArrowUpRight size={18} className="text-stone-400 group-hover:text-[#0F0F10] transition" />
          </Link>
        ))}
      </div>
      <div className="mt-10 rounded-3xl bg-[#0F0F10] text-white p-8 grain relative overflow-hidden">
        <h3 className="heading-display text-3xl">Multi-language ready</h3>
        <p className="mt-3 text-white/70 max-w-2xl">Every page can be edited per language. Use the Languages tab to enable new locales — they will appear automatically on the public site.</p>
        <div className="absolute -right-12 -top-12 w-56 h-56 rounded-full bg-[#1E2DFF] opacity-30 blur-3xl" />
      </div>
    </div>
  );
}
